"use client";
import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import "../../../foundation/iconography/ExtraIconsProvider.js";
import "../../../foundation/iconography/IconVariantProvider.js";
import "../../../foundation/iconography/icons.js";
import { Icon } from "../../../foundation/iconography/Icon.js";
import { BodyText } from "../../../foundation/typography/index.js";
import { forwardRef } from "react";
import classNames from "classnames";
import "../../../foundation/logos/Logo.css.js";
import { clickAnimation } from "../../../styles/animations.css.js";
import { focusStyle, stateLayers } from "../../../styles/states.css.js";
import { tokens } from "@gnist/themes/tokens.css.js";
import { Spinner } from "../../progress/Spinner.js";
import { chipRecipe } from "./styles.css.js";
import { actionText } from "../buttons/styles.css.js";
const FilterChip = forwardRef(function FilterChip2({ label, onClick, selected, loading, density = "default", icon, ...props }, ref) {
  return jsxs("button", { type: "button", ...props, title: label, onClick, className: classNames(chipRecipe({
    selected,
    filterVariant: true,
    loading: loading == null ? void 0 : loading.isLoading
  }), clickAnimation, focusStyle, stateLayers({
    borderSize: "medium",
    borderRadius: "full",
    backgroundColor: "on-background",
    setFocusState: true
  })), ref, children: [(icon || selected) && !(loading == null ? void 0 : loading.isLoading) && jsx(Icon, { icon: selected ? "check" : icon }), (loading == null ? void 0 : loading.isLoading) ? jsx(Spinner, { diameter: density === "compact" ? tokens.size.xs : tokens.size.s, textDescription: loading.loadingText }) : jsx(Fragment, { children: jsx(BodyText, { className: actionText, children: label }) })] });
});
export {
  FilterChip
};
